// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-vantage -> price-brothers-vantage -> piper-lofts
// Generated: 2026-11-03T23:00:58.536Z
// Counts: 3 design, 78 content, 14 slot group, 3 collection binding, 8 section, 1 style

export const designOverrides = {
  "design._site.color.hyperlink": {
    "cssVariable": "--vibe-color-hyperlink",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_secondary_color"
  },
  "design._site.color.linkHover": {
    "cssVariable": "--vibe-color-link-hover",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_color_3"
  },
  "design.block:multihub-tour-scheduler.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_secondary_color"
  }
};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_secondary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Historic Loft Living in the </p><p>Crossroads Arts District</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Loft Apartments in Kansas City</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "scheduletourform.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_company_icon"
  },
  "accessibility-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Inclusive access for every visitor</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Accessibility</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Kansas City Apartments with Rooftop Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Pool, Fitness, Parking &amp; Everyday Conveniences</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply to <span data-type=\"field-token\" data-field=\"property_name\"></span> Apartments</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apply Now</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Piper Lofts at Crossroads in Kansas City</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Connect With Our Crossroads Leasing Team</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Answers to the questions residents ask most at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>1, 2 &amp; 3 Bedroom Apartments in Kansas City</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore Apartment Floor Plans in the Crossroads</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.lets_talk_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Your New Apartment Home Is Waiting</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Kansas City Apartment Photos</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Take a Look Inside Piper Lofts at Crossroads</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/in-unit-laundry-apartments-denton-tx::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore apartments in your area</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/in-unit-laundry-apartments-denton-tx::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Hyperlocal Page Title</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Availability at <span data-type=\"field-token\" data-field=\"property_name\"></span> in <span data-type=\"field-token\" data-field=\"property_address_city\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Interactive Map</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Crossroads Lofts in Kansas City, MO</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore the Crossroads Arts District and Downtown KC</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Rooftop Living Near Downtown Kansas City</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet-Friendly Apartments in Downtown Kansas City</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Pet Policies and Amenities at Piper Lofts at Crossroads</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 14px;\">Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferred-employer-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Price Brothers Management Co. is proud to offer a Preferred Employer Program at <span data-type=\"field-token\" data-field=\"property_name\"></span>! Team members of participating companies receive waived application and administrative fees, making it even easier to call our community home. Have questions or want to see if you qualify? Contact our team—we’re here to help!</p><p>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferred-employer-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Exclusive move-in savings at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferred-employer-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Preferred Employer Program</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerbenefits.eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<p>Program Benefits</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerbenefits.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Exclusive Perks for </h2><h2>Preferred Employers</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerbenefits.intro": {
    "overrideType": "VALUE",
    "customValue": "<p>Price Brothers Management Co. is proud to offer a Preferred Employer Program at <span data-type=\"field-token\" data-field=\"property_name\"></span>! Team members of participating companies receive waived application and administrative fees, making it even easier to call our community home. Have questions or want to see if you qualify? Contact our team—we’re here to help!</p><p>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployercta.eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<h2>Ready to Redeem This Offer?</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployercta.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Ready to Redeem This Offer?</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployercta.subheading": {
    "overrideType": "VALUE",
    "customValue": "<p>Take the next step toward calling <span data-type=\"field-token\" data-field=\"property_name\"></span> home — apply today and enjoy the benefits of our exclusive discount program!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerlist.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p><em>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</em></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerlist.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Our Preferred Employers</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>How we protect your information</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Privacy Policy</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.grid_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Featured Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Piper Lofts at Crossroads Resident Portal</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Manage Your Resident Account Online</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident stories from <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Reviews</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Visit <span data-type=\"field-token\" data-field=\"property_name\"></span> in <span data-type=\"field-token\" data-field=\"property_address_city\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Schedule A Tour</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Each Price Brothers Management Co. community has its own character, amenities, and floor plans. Explore the options above to find the one that feels like home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Nearby Communities From the Price Brothers Management Co.</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore More Places to Call Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Navigate every page on <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Sitemap</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "studios-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover Studio Floor Plans at <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>We'll be in touch soon</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Thank You</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tours of Kansas City Loft Apartments</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore Select Piper Lofts at Crossroads Floor Plans Online</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Enjoy spaces designed for recreation, convenience, and everyday apartment living at Piper Lofts at Crossroads.</p><p>Take in the outdoors at the rooftop pool and sundeck, stay active in the 24-hour fitness center, or spend time in the clubhouse. Additional <a class=\"richtext-link\" href=\"/gallery\">community amenities</a> include an outdoor grilling and picnic area, 24-hour micro-market, coffee and tea bar, covered parking garage, controlled building access, package lockers, elevators, and valet trash service.</p><p></p><h2><strong>Apartment Features with Historic Character</strong></h2><p>Inside each <a class=\"richtext-link\" href=\"/floor-plans\">apartment</a>, original architectural details are paired with contemporary features and finishes. Exposed brick, polished concrete flooring, oversized windows, and high ceilings create distinctive interiors, while granite countertops, stainless steel appliances, dishwashers, in-home washers and dryers, and keyless smart locks add everyday functionality.</p><p>Select apartment homes offer additional features such as kitchen islands, soaking tubs with Jacuzzi jets, and Kansas City skyline views.</p><p>Explore available floor plans or schedule a tour to see the amenities and apartment features at Piper Lofts.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Have questions about apartment availability, <a class=\"richtext-link\" href=\"/floor-plans\">floor plans</a>, <a class=\"richtext-link\" href=\"/amenities\">amenities</a>, tours, or the application process?</p><p>Contact Piper Lofts at Crossroads for additional information about our loft apartments in Kansas City's Crossroads Arts District.</p><p>Use the contact form to send the leasing team a message, call the community, or get directions to Piper Lofts at Crossroads.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Find a layout that fits what you're looking for at Piper Lofts at Crossroads. Explore one-, two-, and three-bedroom apartment floor plans with a <a class=\"richtext-link\" href=\"/virtual-tour\">variety of layouts</a>, square footage, features, and availability.</p><p>Each apartment combines distinctive architectural character with everyday conveniences. High ceilings and oversized windows create open interiors, while features such as granite countertops, stainless steel appliances, dishwashers, in-home washers and dryers, and keyless smart locks bring modern functionality to each space.</p><p>Select floor plans offer additional features, including kitchen islands, soaking tubs with Jacuzzi jets, and views of the Kansas City skyline.</p><p>Browse available one-, two-, and three-bedroom apartments, compare layouts and square footage, and view current pricing and availability at Piper Lofts.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover distinctive <a class=\"richtext-link\" href=\"/floor-plans\">loft apartments</a> in Kansas City at Piper Lofts at Crossroads, where historic architecture and modern apartment living come together in the Crossroads Arts District.</p><p>Located within the former HD Lee building, Piper Lofts preserves original architectural details throughout its one-, two-, and three-bedroom apartments. Exposed brick, polished concrete flooring, oversized windows, and 12-foot ceilings create distinctive interiors, complemented by granite countertops, stainless steel appliances, in-home washers and dryers, and keyless smart locks.</p><p>Explore available floor plans and discover loft living in the heart of Kansas City.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore the Piper Lofts gallery and get a closer look at apartment interiors, community <a class=\"richtext-link\" href=\"/amenities\">amenities</a>, and spaces throughout the property.</p><p>Browse photos of open apartment interiors featuring exposed brick, polished concrete flooring, oversized windows, high ceilings, modern kitchens, and other distinctive details. Then, explore community spaces including the rooftop pool and sundeck, fitness center, clubhouse, outdoor gathering areas, and more.</p><p>The gallery also offers a glimpse of Piper Lofts' historic architecture and its setting within Kansas City's Crossroads Arts District.</p><p>Like what you see? Browse available <a class=\"richtext-link\" href=\"/floor-plans\">floor plans</a> or schedule a <a class=\"richtext-link\" href=\"/schedule-a-tour\">tour</a> to experience Piper Lofts in person.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Piper Lofts at Crossroads is located in Kansas City's Crossroads Arts District, placing residents near galleries, restaurants, entertainment, public spaces, and destinations throughout the downtown area.</p><p>The Crossroads is known for its concentration of galleries and studios, public art, local businesses, and First Fridays events. Nearby destinations include T-Mobile Center, Kauffman Center for the Performing Arts, Power &amp; Light District, Crown Center, Union Station, and the National WWI Museum and Memorial.</p><p>The KC Streetcar provides another way to travel throughout the downtown corridor, connecting the Crossroads with destinations including Union Station and River Market. Nearby parks and outdoor spaces include Washington Square Park, Penn Valley Park, and Liberty Memorial Park.</p><p>Explore the neighborhood surrounding Piper Lofts at Crossroads and discover what you'll find throughout the Crossroads and downtown Kansas City.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.body": {
    "overrideType": "VALUE",
    "customValue": "<p>At Piper Lofts, the Crossroads Arts District is right outside your door. Explore nearby restaurants, galleries, entertainment, and destinations throughout downtown Kansas City, with the KC Streetcar providing connections along the downtown corridor.</p><p>Closer to home, enjoy a <a class=\"richtext-link\" href=\"/amenities\">rooftop pool and sundeck</a>, 24-hour fitness center, clubhouse, outdoor grilling area, micro-market, coffee and tea bar, and covered parking garage.</p><p>Union Station, Crown Center, T-Mobile Center, Kauffman Center for the Performing Arts, Power &amp; Light District, and River Market are among the destinations found throughout the surrounding area.</p><p>Explore the neighborhood or <a class=\"richtext-link\" href=\"/schedule-a-tour\">schedule a tour</a> to experience Piper Lofts at Crossroads.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<h2>Live in Kansas City's Crossroads Arts District</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Piper Lofts at Crossroads welcomes cats and dogs in our downtown Kansas City apartment community. A maximum of two pets is permitted per <a class=\"richtext-link\" href=\"/floor-plans\">apartment home</a>.</p><p>Current pet costs include $25 in monthly pet rent per pet, a $300 non-refundable fee for one pet, or a $500 non-refundable fee for two pets.</p><p>Residents with pets also have access to <a class=\"richtext-link\" href=\"/amenities\">community features</a> including an on-site dog park and pet spa. Additional pet-related benefits may be available through the Price Brothers Pet Royalty Club.</p><p>Pet policies, fees, and restrictions are subject to change. Contact the Piper Lofts at Crossroads leasing team for complete and current pet policy information before applying.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Our community is happy to accept dogs and cats.<br>•&nbsp;Maximum of 2 pets allowed in the apartment home.<br>• Monthly Rent $25 per pet.<br>• $300 non-refundable fee for 1 pet; $500 non-refundable fee for 2 pets.</p><p>Your pets should be treated like royalty! As a resident at Piper Lofts, your furbabies are a part of the exclusive Price Brothers Pet Royalty Club! You can find all of the perks you will receive on the Price Brothers Management website.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Access the Piper Lofts at Crossroads Resident Portal to manage common resident account tasks online.</p><p>Residents can use the portal to make rent payments, review payment information, submit maintenance requests, and access available resident account features from one convenient location.</p><p>Select the Resident Portal link to sign in to your account. Mobile access may also be available through the resident app.</p><p>Need assistance accessing your account? Contact the Piper Lofts at Crossroads property team for additional support.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Use our chatbot to see our interactive tour scheduling assistant or send us a tour request using this form.</p><p><strong>Open Saturdays by Appointment Only</strong></p><p><em>Please contact us directly to schedule for Saturday.</em></p><p>Experience Piper Lofts with a personalized, one-on-one walk-through led by our knowledgeable onsite team members. Our Guided Tours give you the chance to explore amenities, tour model homes, ask questions in real time, and get a true feel for the lifestyle Piper Lofts offers. It's the most interactive, relationship-driven way to experience living at Piper Lofts.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore select lofts at Piper Lofts at Crossroads with virtual tours that provide a closer look at available layouts and loft-style details.</p><p>Move through select apartment homes online to see room configurations, open living areas, kitchens, oversized windows, high ceilings, and other features before scheduling an in-person visit. Virtual tours can also make it easier to compare layouts while reviewing available one-, two-, and three-bedroom options.</p><p>After exploring virtually, browse our complete <a class=\"richtext-link\" href=\"/floor-plans\">floor plan collection</a> to compare current availability, pricing, and square footage at Piper Lofts at Crossroads.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "multihub-lead-form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "",
        "customValue": "/thank-you"
      }
    }
  },
  "hero.rail_schedule": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "custom_self_guided_tour_url",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "contactform.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/01a01005-fcee-740a-9616-7fc62f8ceb0d.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Rooftop pool and lounge area with a city skyline view."
      }
    }
  },
  "floorplanslist.card_image_1": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "floorplanslist.card_image_2": {
    "sourceIndex": 10,
    "fieldOverrides": null
  },
  "scheduletourform.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167655/01a01005-fcee-740a-9616-7fc62f8ceb0d.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Rooftop pool and lounge area with a city skyline view."
      }
    }
  },
  "sisterproperties.community1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Sky on Main apartments in Downtown Kansas City"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Sky on Main"
      },
      "location": {
        "type": "GENERATOR",
        "generatedValue": "920 Main Street, Kansas City, MO 64105"
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "https://www.skyonmain.com/"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Visit Community"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_blank"
      }
    }
  },
  "sisterproperties.community2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "West 39th Street apartments near Westport and KU Med"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "West 39th Street Apartment Homes"
      },
      "location": {
        "type": "GENERATOR",
        "generatedValue": "3895 State Line Rd, Kansas City, MO 64111"
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "https://www.west39th.com/"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Visit Community"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_blank"
      }
    }
  },
  "sisterproperties.community3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Malvern Hill Apartment Homes in Kansas City, Kansas"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Malvern Hill Apartment Homes"
      },
      "location": {
        "type": "GENERATOR",
        "generatedValue": "3942 Adams St, Kansas City, KS 66103"
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "https://www.malvernhillapts.com/"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Visit Community"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_blank"
      }
    }
  },
  "sisterproperties.community4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Mirabelle Luxury Apartments near the Country Club Plaza"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Mirabelle Luxury Apartments"
      },
      "location": {
        "type": "GENERATOR",
        "generatedValue": "310 W. 45th Terrace, Kansas City, MO 64111"
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "https://www.themirabellekc.com/"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Visit Community"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_blank"
      }
    }
  },
  "sisterproperties.community5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "46 Penn Apartment Homes near the Country Club Plaza"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "46 Penn Apartment Homes"
      },
      "location": {
        "type": "GENERATOR",
        "generatedValue": "4551 Pennsylvania Ave, Kansas City, MO 64111"
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "https://www.46penn.com/"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Visit Community"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_blank"
      }
    }
  },
  "sisterproperties.community6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Cambria Luxury Apartment Homes near the Country Club Plaza"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Cambria Luxury Apartment Homes"
      },
      "location": {
        "type": "GENERATOR",
        "generatedValue": "333 W. 46th Terrace, Kansas City, MO 64112"
      },
      "url": {
        "type": "GENERATOR",
        "generatedValue": "https://www.cambriaapts.com/"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Visit Community"
      },
      "_target": {
        "type": "GENERATOR",
        "generatedValue": "_blank"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "propertyoverview.amenities": {
    "limit": 8,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "header.menu_gallery": {
    "limit": null,
    "hiddenIds": [
      "ec_36f035a69154923b5ffb2281"
    ],
    "orderedIds": [
      "ec_49f7e624a871eb8781c0d4c8",
      "ec_c18f15536466e0f82c92d922",
      "ec_f3e3fad7e10aec77550232a0",
      "ec_5a369d9f9d8d5c29cddf8680",
      "ec_a7f4ca9fdf89b34dbcddad1d",
      "ec_9ce0c682075c068cb0412ef9",
      "ec_e11530f4c4a75d0f05ca950a",
      "ec_36f035a69154923b5ffb2281",
      "ec_18f669f8b1bc84d518111250",
      "ec_20c7bbe3018bcdfd92e83477",
      "ec_a1f0931748b59c359a47e457",
      "ec_531b0bb33025ef5565cc8223",
      "ec_b79eda7486a41e932773a0fc",
      "ec_45214e806a7e733c058c48fb",
      "ec_6910fd4e6bba4f779fadc0a8",
      "ec_5b7ec4371ee9785bd2d4fd7a",
      "ec_b8c4349cd1b226db0b94b55a",
      "ec_9ada30b8a2a90af9b08ca7b1"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "photogallery.images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "ec_5a369d9f9d8d5c29cddf8680",
      "ec_20c7bbe3018bcdfd92e83477",
      "ec_9ce0c682075c068cb0412ef9",
      "ec_e11530f4c4a75d0f05ca950a",
      "ec_c18f15536466e0f82c92d922",
      "ec_531b0bb33025ef5565cc8223",
      "ec_b79eda7486a41e932773a0fc",
      "ec_18f669f8b1bc84d518111250",
      "ec_a7f4ca9fdf89b34dbcddad1d",
      "ec_36f035a69154923b5ffb2281",
      "ec_a1f0931748b59c359a47e457",
      "ec_f3e3fad7e10aec77550232a0",
      "ec_6910fd4e6bba4f779fadc0a8",
      "ec_45214e806a7e733c058c48fb",
      "ec_5b7ec4371ee9785bd2d4fd7a",
      "ec_b8c4349cd1b226db0b94b55a",
      "ec_9ada30b8a2a90af9b08ca7b1",
      "ec_49f7e624a871eb8781c0d4c8"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 8
    }
  ],
  "interactive-map": [
    {
      "sectionId": "apartment-sync-map",
      "blockId": "apartment-sync-map",
      "position": 8
    }
  ]
};

export const styleOverrides = {
  "_section.block:apartment-sync-map": {
    "properties": {
      "paddingTop": "15px",
      "paddingRight": "15px",
      "paddingBottom": "15px",
      "paddingLeft": "15px",
      "backgroundColor": "#ffffff"
    }
  }
};
